@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)) {
    <app-multiobjective-responses-summary [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-multiobjective-responses-summary>
  }
  @if (getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)) {
    <app-multicriteria-responses-summary [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-multicriteria-responses-summary>
  }
  @if (getAnalysisService().isConsensusByType(decision_table?.framework.analysis_type)) {
    <app-consensus-responses-summary [evaluationSessionId]="id" [allDecisionInfo]="allInfo" ></app-consensus-responses-summary>
  }
}
